import React, { Fragment, useEffect, useState } from "react";
import axios from "./axios";
// import SystemError from "../components/sharedUI/Error/SystemError";
// import { RedirectBack } from "./utility";
//import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FatalError from "../components/Error/FatalError";
import { funcHandleGenericError } from "../store/actions/AppStateActions";
import { DeleteTokenCookie } from "./SharedUtility";
import NetOffline from "../components/Error/NetOffline";
import SessionOut from "../components/Error/403";

const errorHandler = (Component) => {
  return (props) => {
    //const navigate = useNavigate();
    var netOffline = false;
    if (!navigator.onLine) {
      netOffline = true;
    }
    const dispatch = useDispatch();
    const [error, setError] = useState(null);
    let URL = "";
    const currentAppState = useSelector((state) => state.AppState);
    const funcHandleError = (
      isGenericError,
      handleClick,
      exitEvent,
      errorMessage
    ) =>
      dispatch(
        funcHandleGenericError(
          isGenericError,
          handleClick,
          exitEvent,
          errorMessage
        )
      );

    const reqInterceptor = axios.interceptors.request.use((req) => {
      setError(null);
      URL = req.url;
      return req;
    });

    const handleError = () => {
      currentAppState?.isGenericError && funcHandleError(false, null, null, "");
    };

    const resInterceptor = axios.interceptors.response.use(
      (res) => res,
      (err) => {
        handleError();
        if (err.response && err.response.status === 403) {
          DeleteTokenCookie();
        }
        if (!URL.includes("audit-log")) {
          setError(err);
          return Promise.reject(err);
        }
      }
    );

    useEffect(() => {
      return () => {
        axios.interceptors.request.eject(reqInterceptor);
        axios.interceptors.response.eject(resInterceptor);
      };
    }, [reqInterceptor, resInterceptor]);

    return (
      <Fragment>
        {
          //if user is offline load netoffline component
          netOffline ? (
            <NetOffline />
          ) : //else check for any system error which are present in online appication if present load fatal error component
          error?.response?.status === 403 ? (
            <SessionOut />
          ) : error?.message ? (
            <FatalError />
          ) : (
            // if everything works as expected load the child component
            <Component
              {...props}
              setError={(e) => {
                setError(e);
              }}
            />
          )
        }
      </Fragment>
    );
  };
};

export default errorHandler;
